import { render, staticRenderFns } from "./BIM.vue?vue&type=template&id=04a9a176&scoped=true&"
import script from "./BIM.vue?vue&type=script&lang=js&"
export * from "./BIM.vue?vue&type=script&lang=js&"
import style0 from "./BIM.vue?vue&type=style&index=0&id=04a9a176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9a176",
  null
  
)

export default component.exports